import React from "react";
import { Input, Row } from "reactstrap";
import { ColPrompt } from "./index";
import { ColValue, ErrorDiv } from "../ProductionModule/index";
import { useMachineSetupContextUpdater } from "./useMachineSetupContextUpdater";
import { useMachineSetupContextState } from "./useMachineSetupContextState";
// Used by the Heli (Pirn) KV2002 machine

export default function ItineraryTraverseRow() {
   const { handleInputRangeChange } = useMachineSetupContextUpdater();
   const { machineSetup, errorDivDefinitions } = useMachineSetupContextState();
   const defaultOnChangeVal = {target: {value: ""}};

   return (
      <Row className="mb-2">
         <ColPrompt title={"Itinerary/Traverse"} bold={true} description={"mm"} />
         <ColValue size={2}>
            Min:
            <Input
               type="text"
               style={{ borderRadius: "10px", fontSize: "14px" }}
               value={machineSetup.extendedPropertyJson.traverseMin || ""}
               onChange={(e) =>
                  e.target.value
                     ? handleInputRangeChange(e, 0, 553.5, "traverseMin", "float")
                     : handleInputRangeChange(defaultOnChangeVal, 0, 555.3, "traverseMin")
               }
            />
            {errorDivDefinitions.traverseMin && <ErrorDiv>0-553.5 only</ErrorDiv>}
         </ColValue>
         <ColValue size={2}>
            Max:
            <Input
               type="text"
               style={{ borderRadius: "10px", fontSize: "14px" }}
               value={machineSetup.extendedPropertyJson.traverseMax || ""}
               onChange={(e) =>
                  e.target.value
                     ? handleInputRangeChange(e, 0, 553.5, "traverseMax", "float")
                     : handleInputRangeChange(defaultOnChangeVal, 0, 555.3, "traverseMax")
               }
            />
            {errorDivDefinitions.traverseMax && <ErrorDiv>0-553.5 only</ErrorDiv>}
         </ColValue>
      </Row>
   );
}
